import React, { useEffect, useState } from 'react'
import {
  Card,
  Row,
  Col,
  Button,
  Divider,
  Checkbox,
  Spin,
  Form,
  Input,
  Select,
  message,
  Modal,
  Space
} from 'antd'
import { InputGroup } from 'reactstrap'
import IntlMessages from '../../../util/IntlMessages'
import { useHistory } from 'react-router-dom'
import {
  ArrowLeftOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone
} from '@ant-design/icons'
import ds from '../../../Services/DataServices'
import {
  isString,
  notAllowMsgCheck,
  setCommonConfigs
} from '../../../appRedux/actions'
import { PAYMENT_SCREEN } from '../../../constants/Pages'
import {
  READ,
  CREATE,
  UPDATE,
  DELETE
} from '../../../constants/RightsAndPermissions'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import { useDispatch, useSelector } from 'react-redux'
import NotAllowedComponent from '../../../components/NotAllowedComponent'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const RoundTo = [
  {
    id: 1,
    value: '0.1 (1 decimal point)'
  },
  {
    id: 2,
    value: '0.05 (2 decimal point)'
  },
  {
    id: 3,
    value: '0.105 (3 decimal point)'
  }
]

const AddEditPayment = ({ match }) => {
  const id = match.params.id
  // const isDelete = match.params.isdelete;
  const name = match.params.sourceid
    ? match.params.sourceid.substring(0, match.params.sourceid.indexOf('&'))
    : false
  const payName = id && name && name == '6' ? 'Trustly' : match.params.payname
  const history = useHistory()
  const confirm = Modal.confirm
  const [form] = Form.useForm()
  const dispatch = useDispatch()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )

  const [confirmLoading, setConfirmLoading] = useState(false) // change state
  const [getIsConceal, setIsConceal] = useState(false)
  const [storeOutlets, setStoreOutlets] = useState([])
  const [getCurrencies, setCurrencies] = useState([])
  const [getPayTypeName, setPayTypeName] = useState('')
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [nameExist, setNameExist] = useState(false)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])

  useEffect(() => {
    dispatch(setCommonConfigs(PAYMENT_SCREEN))
    setConfirmLoading(true)
    let array = []
    ds.getStoreOutletPromise('', BEHAVIOUR_TYPE.GET)
      .then(res => {
        array = res.data.map(e => {
          return {
            id: e.sOutletId.substring(0, e.sOutletId.indexOf('&')),
            outlet: e.outletName
          }
        })

        setStoreOutlets(array)
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
      })
      .then(() => {
        ds.getPaymentTypeSpecificId(
          { PaymentSId: id ? id : '' },
          BEHAVIOUR_TYPE.GET
        )
          .then(res => {
            if (res.currencies && res.currencies.length > 0) {
              setCurrencies(res.currencies)
            }
            setConfirmLoading(false)
            setPayTypeName(res.paymentTypeName)
            setIsConceal(res.isConceal)
            // let roundings = [];
            // let roundingRule = "";
            // if (res.rounding && res.rounding != "") {
            //   roundings = res.rounding.includes(" ")
            //     ? res.rounding.split(" ")
            //     : [];
            //   if (roundings.length > 1) {
            //     roundingRule = roundings[1].replaceAll("(", "");
            //     roundingRule = roundingRule.replaceAll(")", "");
            //   }
            // }
            form.setFieldsValue({
              Name: res.paymentTypeName,
              clientID: res.clientID ? res.clientID : '',
              clientSecret: res.clientSecret ? res.clientSecret : '',
              clientCode: res.clientCode ? res.clientCode : '',
              clientPass: res.clientPassword ? res.clientPassword : '',
              clientPass: res.clientPassword ? res.clientPassword : '',
              currency: res.currency ? res.currency : '',
              skinFolder: res.skinFolder ? res.skinFolder : '',
              BGColor: res.bgColor ? res.bgColor : '',
              roundTo: res.rounding ? parseInt(res.rounding) : 2,
              terminialSN: res.terminalSN ? res.terminalSN : ''
              // roundRule: roundingRule != "" ? roundingRule : "R_M_U",
            })

            if (res.outlets && res.outlets.length > 0) {
              let outletIDs = res.outlets.map(e =>
                e.substring(0, e.indexOf('&'))
              )
              outletIDs.map(w => {
                let id = array.filter(q => q.id == w)
                if (id.length < 1) {
                  outletIDs = outletIDs.filter(r => r != w)
                }
              })
              form.setFieldsValue({ Outlets: outletIDs })
            }
          })
          .catch(error => {
            notAllowMsgCheck(error)
            message.error('Unable to get data')
            setConfirmLoading(false)
          })
      })
  }, [])

  //rights & permissions
  React.useEffect(() => {
    let commonData = getReduxCommonSetting
    let rites = []
    let permissions = []
    if (
      commonData &&
      commonData.storeCommonConfigs &&
      commonData.storeCommonConfigs.storeConfig &&
      commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
    ) {
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
          .length > 0
      ) {
        rites =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setRights(rites)
      }
      if (
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission &&
        commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission
          .permission.length > 0
      ) {
        permissions =
          commonData.storeCommonConfigs.storeConfig.pageRiteAndPermission.rites
        setPermissions(permissions)
      }
    }

    if (rites.length > 0) {
      if (rites.filter(a => a == READ).length > 0) {
        setIsAllowRead(true)
      }
      if (rites.filter(a => a == CREATE).length > 0) {
        setIsDisableCreate(false)
        //redirect from home
        // if (window.location.href.includes("/mainadd")) {
        //   setVisible(true);
        // }
      }
      // else {
      //   if (window.location.href.includes("/mainadd")) {
      //     message.info("User don't have the right to create.");
      //   }
      // }
      if (rites.filter(a => a == UPDATE).length > 0) {
        setIsDisableUpdate(false)
      }
      if (rites.filter(a => a == DELETE).length > 0) {
        setIsDisableDelete(false)
      }
    }

    if (commonData && commonData.storeCommonConfigs) {
      setAccessLoading(false)
    }
  }, [getReduxCommonSetting])

  const redirectToListing = () => {
    history.push('/Dashboard/Setup/PaymentTypes/main')
  }

  const submitValues = values => {
    setConfirmLoading(true)
    const methType = id ? BEHAVIOUR_TYPE.UPDATE : BEHAVIOUR_TYPE.POST
    ds.saveUpdatePaymentTypes(
      {
        PaymentName: values.Name,
        isConceal: getIsConceal,
        Behavior: id ? 3 : 1,
        Outlets: values.Outlets,
        PayTypeSourceID: `${name}&&_XYU78_XAPO81_UI3WQ2`,
        ClientID: values.clientID ? values.clientID : '',
        ClientSecret: values.clientSecret ? values.clientSecret : '',
        ClientCode: values.clientCode ? values.clientCode : '',
        ClientPassword: values.clientPass ? values.clientPass : '',
        Currency: values.currency ? values.currency : '',
        SkinFolder: values.skinFolder ? values.skinFolder : '',
        BGColor: values.BGColor ? values.BGColor : '',
        Rounding: values.roundTo ? `${values.roundTo}` : '',
        TerminalSN: values.terminialSN ? values.terminialSN : '',
        PaymentSId: id ? id : ''
      },
      methType
    )
      .then(res => {
        if (res && res == 'Created') {
          message.success('Saved Successfully')
        } else if (res && res == 'Deleted') {
          message.success('Removed successfully')
        } else if (res && res == 'Updated') {
          message.success('Updated Successfully')
        } else if (res && res == 'already_exist') {
          message.info('Payment name already exist', 3)
          setNameExist(true)
        }
        setConfirmLoading(false)
        if (res && res != 'already_exist') redirectToListing()
      })
      .catch(error => {
        notAllowMsgCheck(error)
        setConfirmLoading(false)
        setNameExist(false)
        message.error('Unable to save data')
      })
  }

  const handleDelete = paymentid => {
    ds.saveUpdatePaymentTypes(
      { Behavior: 2, PaymentSId: paymentid },
      BEHAVIOUR_TYPE.DELETE
    )
      .then(res => {
        redirectToListing()
      })
      .catch(error => {
        notAllowMsgCheck(error)
      })
  }

  const showConfirmDelete = id => {
    confirm({
      title: `Delete ${getPayTypeName}?`,
      content: `"Are you sure you want to delete"`,
      okText: 'Yes',
      cancelText: 'No',
      okButtonProps: { className: 'dk-btn-add close-reg-btn' },
      cancelButtonProps: { className: 'dk-btn-cancel close-reg-btn' },
      onOk () {
        handleDelete(id)
      },
      onCancel () {
        //console.log('Cancel');
      }
    })
  }

  const onFinishFailed = errorInfo => {
    setConfirmLoading(false)
    message.warn('Kindly Attend to Missing Fields')
  }

  return getIsAllowRead ? (
    <Spin
      tip={<IntlMessages id='sell.cashlisting.cashloading' />}
      spinning={confirmLoading}
      size='large'
    >
      {name && (
        <div className='Content-wrapper PaymentType-pg'>
          <div className='back-arrow-h1'>
            <h1 className='d-flex align-items-center'>
              <ArrowLeftOutlined
                className='dk-vertical-align'
                onClick={redirectToListing}
              />
              <span className='mx-2'>{payName ? payName : 'Payment Type'}</span>
            </h1>
          </div>

          <Row className='ant-row dk-row-bg-color m-0 Sec-heading-bg'>
            <Col lg={18} md={16} sm={14} xs={24}>
              <p className='title vd-hero-intro custom-font-color-black m-0'>
                <IntlMessages id='setup.paymentTypes.editAddDescription' />
              </p>
            </Col>
            <Col lg={6} md={8} sm={10} xs={24}>
              <div className='pg-header-btn'>
                <Button
                  className='dk-btn-add'
                  type='primary'
                  form='AddPaymentTypeForm'
                  htmlType='submit'
                  size='large'
                  disabled={getIsDisableCreate || getIsDisableUpdate}
                >
                  <IntlMessages id='setup.paymentTypes.savePayTypeButton' />
                </Button>
              </div>
            </Col>
          </Row>

          <div className='custom-mg-top-25'>
            <Form
              {...formItemLayout}
              form={form}
              onFinish={submitValues}
              onFinishFailed={onFinishFailed}
              // initialValues={{
              //   prefix: "86",
              // }}
              className='custom-mg-top-26'
              scrollToFirstError
              id='AddPaymentTypeForm'
              name='AddPaymentTypeForm'
              initialValues={{
                roundTo: 2
              }}
            >
              <Row>
                <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                  <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                    <IntlMessages id='setup.paymentTypes.paymentInfoTitle' />
                  </h2>
                  <p className='dk-font-size-15'>
                    <IntlMessages id='setup.paymentTypes.paymentInfoDesc' />
                  </p>
                </Col>

                <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                  <InputGroup size='large' className='md-col-100'>
                    <Form.Item
                      className='ant-form-custom-alignment'
                      name='Name'
                      label={
                        <IntlMessages id='setup.paymentTypes.paymentInfoNameLabel' />
                      }
                      rules={[
                        {
                          required: true,
                          message: 'Payment method name required'
                        }
                      ]}
                      {...{
                        help: nameExist && 'Name Already Exist',
                        hasFeedback: true,
                        validateStatus: nameExist ? 'error' : ''
                      }}
                    >
                      <Input
                        onFocus={() => {
                          if (nameExist) setNameExist(false)
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      className='ant-form-custom-alignment'
                      name='Outlets'
                      label={
                        <IntlMessages id='setup.paymentTypes.paymentInfoOutletLabel' />
                      }
                      rules={[
                        {
                          required: true,
                          message: 'Required'
                        }
                      ]}
                    >
                      <Select
                        placeholder={
                          <IntlMessages id='setup.paymentTypes.paymentInfoChooseOutletLabel' />
                        }
                        mode='multiple'
                        size='large'
                        showSearch
                        optionFilterProp='children'
                      >
                        {storeOutlets &&
                          storeOutlets.map(e => {
                            return (
                              <Select.Option value={e.id} key={e.id}>
                                {e.outlet}
                              </Select.Option>
                            )
                          })}
                      </Select>
                    </Form.Item>
                  </InputGroup>

                  <Form.Item
                    className='ant-form-custom-alignment md-inner-pad-0'
                    name='paymentType'
                    label={
                      <IntlMessages id='setup.paymentTypes.paymentInfoTypeLabel' />
                    }
                  >
                    <h3 className='d-flex align-items-center'>
                      <i class={`icon icon-tag text-orange mr-2`}></i>
                      {payName ? payName : ''}
                      {/* {name == '1'
                          ? 'CASH'
                          : name == '2'
                          ? 'APCO'
                          : name == '3'
                          ? 'PayPal'
                          : 'Payment Types'} */}
                    </h3>
                  </Form.Item>
                </Col>
              </Row>

              {name == '1' ? (
                <>
                  <Divider className='mt-0 mb-4' />

                  <Row>
                    <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        <IntlMessages id='setup.paymentTypes.roundingTitle' />
                      </h2>
                      <p className='dk-font-size-15'>
                        <IntlMessages id='setup.paymentTypes.roundingDesc' />
                      </p>
                    </Col>

                    <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                      <Form.Item
                        className='ant-form-custom-alignment md-inner-pad-0'
                        name='roundTo'
                        label={
                          <IntlMessages id='setup.paymentTypes.roundingLabel' />
                        }
                      >
                        <Select
                          size='large'
                          placeholder={
                            <IntlMessages id='setup.paymentTypes.paymentInfoChooseRoundLabel' />
                          }
                        >
                          {RoundTo &&
                            RoundTo.map(e => {
                              return (
                                <Select.Option value={e.id} key={e.id}>
                                  {`${e.value} `}
                                  {/* <IntlMessages id="setup.paymentTypes.denomination" /> */}
                                </Select.Option>
                              )
                            })}
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Divider className='mt-3 mb-4' />

                  <Row>
                    <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                      <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                        <IntlMessages id='setup.paymentTypes.concealTitle' />
                      </h2>
                      <p className='dk-font-size-15'>
                        <IntlMessages id='setup.paymentTypes.concealDesc' />
                      </p>
                    </Col>

                    <Col
                      xl={18}
                      lg={24}
                      md={24}
                      sm={24}
                      xs={24}
                      className='md-pad-0'
                    >
                      <Form.Item name='conceal'>
                        <Checkbox
                          className=''
                          checked={getIsConceal}
                          onChange={value => setIsConceal(value.target.checked)}
                        >
                          <IntlMessages id='setup.paymentTypes.concealLabel' />
                        </Checkbox>
                      </Form.Item>
                    </Col>
                  </Row>
                </>
              ) : (
                <>
                  <Divider className='mt-3 mb-4' />

                  {(name == '2' || name == '3') && (
                    <>
                      <div className='custom-mg-top-25'>
                        <Row>
                          <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                              <IntlMessages id='setup.paymentTypes.clientid' />
                            </h2>
                            <p className='dk-font-size-15'>
                              <IntlMessages id='setup.paymentTypes.clientidform' />
                            </p>
                          </Col>

                          <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                            <InputGroup size='large' className='gx-mb-3'>
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                                name='clientID'
                                label={
                                  <IntlMessages id='setup.paymentTypes.clientid' />
                                }
                                rules={[
                                  {
                                    required: true,
                                    message: 'Required'
                                  }
                                ]}
                              >
                                <Input placeholder='Enter your Client ID' />
                              </Form.Item>
                            </InputGroup>
                          </Col>
                        </Row>
                      </div>

                      <Divider className='mt-3 mb-4' />

                      <Row>
                        <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                          <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                            <IntlMessages id='setup.paymentTypes.clientsecret' />
                          </h2>
                          <p className='dk-font-size-15'>
                            <IntlMessages id='setup.paymentTypes.clientsecrethelper' />
                          </p>
                        </Col>

                        <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                          <InputGroup size='large' className='gx-mb-3'>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='clientSecret'
                              label={
                                <span>
                                  <IntlMessages id='setup.paymentTypes.clientsecret' />
                                </span>
                              }
                              rules={[
                                {
                                  required: true,
                                  message: 'Required'
                                }
                              ]}
                            >
                              <Input placeholder='Enter your Client Secret' />
                            </Form.Item>
                          </InputGroup>
                        </Col>
                      </Row>

                      <Divider className='mt-3 mb-4' />

                      <Row>
                        <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                          <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                            <IntlMessages id='setup.paymentTypes.currency' />
                          </h2>
                          <p className='dk-font-size-15'>
                            <IntlMessages id='setup.paymentTypes.selpayment' />
                          </p>
                        </Col>

                        <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                          <InputGroup size='large' className='gx-mb-3'>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='currency'
                              label={
                                <span>
                                  <IntlMessages id='setup.paymentTypes.currency' />
                                </span>
                              }
                              rules={[
                                {
                                  required: true,
                                  message: 'Required'
                                }
                              ]}
                            >
                              <Select
                                placeholder={
                                  <IntlMessages id='setup.paymentTypes.currencies' />
                                }
                                //   mode="multiple"
                                size='large'
                                showSearch
                                optionFilterProp='children'
                              >
                                {getCurrencies &&
                                  getCurrencies.map(e => {
                                    return (
                                      <Select.Option
                                        value={e.currCode}
                                        key={e.id}
                                      >
                                        {e.label}
                                      </Select.Option>
                                    )
                                  })}
                              </Select>
                            </Form.Item>
                          </InputGroup>
                        </Col>
                      </Row>
                    </>
                  )}

                  {name == '2' && (
                    <>
                      <Divider className='mt-3 mb-4' />

                      <Row>
                        <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                          <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                            <IntlMessages id='setup.paymentTypes.clientcode' />
                          </h2>
                          <p className='dk-font-size-15'>
                            <IntlMessages id='setup.paymentTypes.clientcode' />
                          </p>
                        </Col>

                        <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                          <InputGroup size='large' className='gx-mb-3'>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='clientCode'
                              label={
                                <span>
                                  <IntlMessages id='setup.paymentTypes.clientcode' />
                                </span>
                              }
                              rules={[
                                {
                                  required: true,
                                  message: 'Required'
                                }
                              ]}
                            >
                              <Input placeholder='Enter your Client CODE' />
                            </Form.Item>
                          </InputGroup>
                        </Col>
                      </Row>

                      <Divider className='mt-3 mb-4' />

                      <div className='custom-mg-top-25'>
                        <Row>
                          <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                              <IntlMessages id='setup.paymentTypes.clientpassword' />
                            </h2>
                            <p className='dk-font-size-15'>
                              <IntlMessages id='setup.paymentTypes.provpass' />
                            </p>
                          </Col>

                          <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                            <InputGroup size='large' className='gx-mb-3'>
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                                name='clientPass'
                                label={
                                  <span>
                                    <IntlMessages id='setup.paymentTypes.clientpassword' />
                                  </span>
                                }
                                rules={[
                                  {
                                    required: true,
                                    message: 'Required'
                                  }
                                ]}
                              >
                                <Input placeholder='Enter your Client Password' />
                              </Form.Item>
                            </InputGroup>
                          </Col>
                        </Row>

                        <Divider className='mt-3 mb-4' />

                        <Row>
                          <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                              <IntlMessages id='setup.paymentTypes.bgcolor' />
                            </h2>
                            <p className='dk-font-size-15'>
                              <IntlMessages id='setup.paymentTypes.backcolor' />
                            </p>
                          </Col>

                          <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                            <InputGroup size='large' className='gx-mb-3'>
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                                name='BGColor'
                                label={
                                  <strong>
                                    <IntlMessages id='setup.paymentTypes.bgcolor' />
                                  </strong>
                                }
                              >
                                <Input placeholder='HEX COLOR' />
                              </Form.Item>
                            </InputGroup>
                          </Col>
                        </Row>
                      </div>

                      <Divider className='mt-3 mb-4' />

                      <Row>
                        <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                          <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                            <IntlMessages id='setup.paymentTypes.skinfolder' />
                          </h2>
                          <p className='dk-font-size-15'>
                            <IntlMessages id='setup.paymentTypes.skinfolerform' />
                          </p>
                        </Col>

                        <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                          <InputGroup size='large' className='gx-mb-3'>
                            <Form.Item
                              className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                              name='skinFolder'
                              label={
                                <span>
                                  <IntlMessages id='setup.paymentTypes.skinfolder' />
                                </span>
                              }
                            >
                              <Input placeholder='' />
                            </Form.Item>
                          </InputGroup>
                        </Col>
                      </Row>
                    </>
                  )}

                  {payName &&
                    isString(payName) &&
                    payName.toLowerCase().includes('trust') && (
                      <>
                        <Row>
                          <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                              Site ID
                            </h2>
                            <p className='dk-font-size-15'>
                              Carefully provide your Site ID correctly.
                            </p>
                          </Col>

                          <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                            <InputGroup size='large' className='md-col-100'>
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                                name='clientID'
                                label={<span>Site ID</span>}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Required'
                                  }
                                ]}
                              >
                                <Input placeholder='Enter your Site ID' />
                              </Form.Item>
                            </InputGroup>
                          </Col>
                        </Row>

                        <Divider className='mt-3 mb-4' />

                        <Row>
                          <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                              Password
                            </h2>
                            <p className='dk-font-size-15'>
                              Carefully provide your password correctly.
                            </p>
                          </Col>

                          <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                            <InputGroup size='large' className='md-col-100'>
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment password-fix'
                                name='clientPass'
                                label={<span>Password</span>}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Required'
                                  }
                                ]}
                              >
                                <Input.Password
                                  size='large'
                                  placeholder='Input Password'
                                  iconRender={visible =>
                                    visible ? (
                                      <EyeTwoTone />
                                    ) : (
                                      <EyeInvisibleOutlined />
                                    )
                                  }
                                />
                                {/* <Input placeholder='Enter your Password Carefully' /> */}
                              </Form.Item>
                            </InputGroup>
                          </Col>
                        </Row>

                        <Divider className='mt-3 mb-4' />

                        <Row>
                          <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                              Terminal Serial Number
                            </h2>
                            <p className='dk-font-size-15'>
                              Carefully provide your Terminal Serial Number
                              correctly.
                            </p>
                          </Col>

                          <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                            <InputGroup size='large' className='md-col-100'>
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                                name='terminialSN'
                                label={<strong>Terminal Serial Number</strong>}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Required'
                                  }
                                ]}
                              >
                                <Input placeholder='Enter your Terminal Serial Number' />
                              </Form.Item>
                            </InputGroup>
                          </Col>
                        </Row>

                        <Divider className='mt-3 mb-4' />

                        <Row>
                          <Col xl={6} lg={24} md={24} sm={24} xs={24}>
                            <h2 className='custom-font-weight-500 custom-font-color-black heading-fonts-adjust'>
                              <IntlMessages id='setup.paymentTypes.currency' />
                            </h2>
                            <p className='dk-font-size-15'>
                              <IntlMessages id='setup.paymentTypes.selpayment' />
                            </p>
                          </Col>

                          <Col xl={18} lg={24} md={24} sm={24} xs={24}>
                            <InputGroup size='large' className='md-col-100'>
                              <Form.Item
                                className='ant-form-item-label-custom ant-form-margin-right ant-form-custom-alignment'
                                name='currency'
                                label={
                                  <strong>
                                    <IntlMessages id='setup.paymentTypes.currency' />
                                  </strong>
                                }
                                rules={[
                                  {
                                    required: true,
                                    message: 'Required'
                                  }
                                ]}
                              >
                                <Select
                                  placeholder={
                                    <IntlMessages id='setup.paymentTypes.currencies' />
                                  }
                                  //   mode="multiple"
                                  size='large'
                                  showSearch
                                  optionFilterProp='children'
                                >
                                  {getCurrencies &&
                                    getCurrencies.map(e => {
                                      return (
                                        <Select.Option
                                          value={e.currCode}
                                          key={e.id}
                                        >
                                          {e.label}
                                        </Select.Option>
                                      )
                                    })}
                                </Select>
                              </Form.Item>
                            </InputGroup>
                          </Col>
                        </Row>
                      </>
                    )}
                </>
              )}

              {id ? (
                <>
                  <Divider className='mt-3 mb-4' />

                  <div className='text-right'>
                    <Button
                      className='dk-btn-cancel'
                      type='primary'
                      onClick={() => showConfirmDelete(id)}
                      size='large'
                      // disabled={isDelete && isDelete == "1" ? false : true}
                      disabled={getIsDisableDelete}
                    >
                      <IntlMessages id='setup.paymentTypes.deletePaymentTitle' />
                    </Button>
                  </div>
                </>
              ) : (
                ''
              )}
            </Form>
          </div>
        </div>
      )}
    </Spin>
  ) : (
    <NotAllowedComponent getAccessLoading={getAccessLoading} textType={1} />
  )
}

export default AddEditPayment
